import { t } from "@/i18n-js/instance";
import { Toolbar } from "@circle-react/components/LiveStreams/Room/Toolbar";
import type { Room } from "@circle-react/types/Live/Room";
import { LeaveButton } from "../Buttons/LeaveButton";
import { useGuests, useParticipants } from "../hooks";
import {
  SIDEBAR_VIEWS,
  usePublicLiveStore,
  usePublicLiveStoreActions,
} from "../store";

const GUEST_REFETCH_INTERVAL = 30 * 1000; //30s

interface FooterProps {
  room?: Room;
}

export const Footer = ({ room }: FooterProps): JSX.Element => {
  const { toggleChatSidebar, toggleParticipantsSidebar } =
    usePublicLiveStoreActions();
  const { sidebarView } = usePublicLiveStore();
  const isSidebarOpen = !!sidebarView;
  const isChatActive = sidebarView === SIDEBAR_VIEWS.CHAT;

  const { activeCount: activeParticipantCount } = useParticipants();
  const { count: guestCount } = useGuests({
    refetchInterval: GUEST_REFETCH_INTERVAL,
  });
  const totalParticipantCount = activeParticipantCount + guestCount;
  const shouldHideParticipantsButton = !!room?.hide_participants_list;

  return (
    <Toolbar autoHide={false}>
      <Toolbar.Group>
        <Toolbar.Item />
      </Toolbar.Group>
      <Toolbar.Group>
        <Toolbar.Button
          icon="live-chat"
          tooltipText={t("live_streams.room.button_tooltips.chat")}
          aria-label={t("live_streams.room.button_tooltips.chat")}
          onClick={toggleChatSidebar}
          active={isSidebarOpen && isChatActive}
        />
        {!shouldHideParticipantsButton && (
          <Toolbar.Button
            tooltipText={t("live_streams.room.button_tooltips.participants")}
            aria-label={t("live_streams.room.button_tooltips.participants")}
            onClick={toggleParticipantsSidebar}
            active={isSidebarOpen && !isChatActive}
            icon="live-users"
            label={totalParticipantCount}
          />
        )}
      </Toolbar.Group>
      <Toolbar.Group>
        <LeaveButton />
      </Toolbar.Group>
    </Toolbar>
  );
};
